import axios, { AxiosRequestConfig } from "axios";
import { Tokens } from "../../types/webchatConversation";
import getAxiosConfig from "../other/axiosConfig";
import { removeFromCookie } from "../other/cookies";

const logoutHelper = async () => {
  const config: AxiosRequestConfig = getAxiosConfig(
    "POST",
    "/users-auth/logout",
    "bearer",
  );

  const response = await axios(config);

  const { data } = response;
  const { code } = data;

  if (code !== 200) {
    throw new Error("Logout failed!");
  }

  // Brišemo kolačiće
  removeFromCookie(Tokens.AUTH_TOKEN);
  removeFromCookie(Tokens.GUEST_TOKEN);
};

export default logoutHelper;
